package foatto.core.app

const val UP_TIME_OFFSET = "time_offset"
const val UP_IS_USE_THOUSANDS_DIVIDER = "is_use_thousands_divider"
const val UP_DECIMAL_DIVIDER = "decimal_divider"

const val ICON_NAME_ADD_FOLDER = "add_folder"
const val ICON_NAME_ADD_ITEM = "add_item"
const val ICON_NAME_ARCHIVE = "archive"
const val ICON_NAME_BOSS = "boss"
const val ICON_NAME_DELETE = "delete"
const val ICON_NAME_DIVISION = "division"
const val ICON_NAME_EXIT = "exit"
const val ICON_NAME_FILE = "file"
const val ICON_NAME_FOLDER = "folder"
const val ICON_NAME_GRAPHIC = "graphic"
const val ICON_NAME_MAP = "map"
const val ICON_NAME_PRINT = "print"
const val ICON_NAME_SAVE = "save"
const val ICON_NAME_SELECT = "select"
const val ICON_NAME_STATE = "state"
const val ICON_NAME_UNARCHIVE = "unarchive"
const val ICON_NAME_VIDEO = "video"
const val ICON_NAME_WORKER = "worker"

const val BUTTON_KEY_NONE = 0
const val BUTTON_KEY_EXIT = 1
const val BUTTON_KEY_SAVE = 2
const val BUTTON_KEY_AUTOCLICK = 3

const val PARAM_ZONE_NAME = "zone_name"
const val PARAM_ZONE_DESCR = "zone_descr"

const val STATE_ALERT_MESSAGE = "state_alert_message"
const val STATE_ELEMENT_MOVE_ENABLED: String = "state_element_move_enabled"
const val STATE_ELEMENT_MOVE_ID: String = "state_element_move_id"
const val STATE_ELEMENT_MOVE_DESCR: String = "state_element_move_descr"
const val STATE_ELEMENT_MOVE_X: String = "state_element_move_x"
const val STATE_ELEMENT_MOVE_Y: String = "state_element_move_y"

